<div class="app-breadcrumb-main">
    <h2>{{ pageTitle | translate }}</h2>
    <div class="app-breadcrumb">
        <div class="link-group">
            @for (item of breadcrumbs; track $index) {
                @if ($index === 0) {
                    <a routerLinkActive="active-breadcrumb-link" [routerLinkActiveOptions]="{ exact: true }">
                        {{ item.label | translate }}
                    </a>
                    @if ($index < breadcrumbs.length - 1) {
                        <img src="../../../assets/img/navRight.svg" alt="arrow" />
                    }
                } @else {
                    <a
                        [routerLink]="item.link"
                        [queryParams]="item.queryParams"
                        routerLinkActive="active-breadcrumb-link"
                        [routerLinkActiveOptions]="{ exact: true }"
                    >
                        {{ item.label | translate }}
                    </a>
                    @if ($index < breadcrumbs.length - 1) {
                        <img src="../../../assets/img/navRight.svg" alt="arrow" />
                    }
                }
            }
        </div>
        <div>
            <ng-content></ng-content>
        </div>
    </div>
</div>
